import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  ROUTES
} from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import { DeviceDetectorService } from 'ngx-device-detector';
import { routesFactory } from './client.routes'; // 
import { FilesExpiredComponent } from './files-expired/files-expired.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ServiceUnavailableComponent } from './service-unavailable/service-unavailable.component';
import { DeletedComponent } from './deleted/deleted.component';
import { RedirectComponent } from './redirect/redirect.component';
import { SuspendedComponent } from './suspended/suspended.component';
import { UnsupportedComponent } from './unsupported/unsupported.component';
import { UsageExceededComponent } from './usage-exceeded/usage-exceeded.component';
import { InvalidConfigurationComponent } from '@app/client/invalid-configuration/invalid-configuration.component';
import { RequestExpiredComponent } from './request-expired/request-expired.component';

@NgModule({
  declarations: [
    FilesExpiredComponent,
    PageNotFoundComponent,
    ServiceUnavailableComponent,
    UnsupportedComponent,
    SuspendedComponent,
    DeletedComponent,
    RedirectComponent,
    InvalidConfigurationComponent,
    UsageExceededComponent,
    RequestExpiredComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
  ],
  providers: [{
    provide: ROUTES,
    useFactory: routesFactory,
    multi: true,
    deps: [DeviceDetectorService]
  }],
})
export class ClientModule {
  constructor() { }

}

